import React, { useState } from 'react';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import CustomTabs from 'components/CustomTabs';
import { DASHBOARD_TABS } from '../constant';
import Listings from './components/LISTINGS';
import Bids from './components/Bids';
import Vendors from './components/Vendors';
import Invoices from './components/Invoices';

const AllTabsAndTables = ({ permissions }) => {
  const [activeTab, setActiveTab] = useState(DASHBOARD_TABS.LISTINGS);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <CustomTabs
        className="dashboard-tab-list mb-3"
        tabs={[
          DASHBOARD_TABS.LISTINGS,
          DASHBOARD_TABS.BIDS,
          DASHBOARD_TABS.VENDORS,
          DASHBOARD_TABS.INVOICES,
        ]}
        selectedTab={activeTab}
        onTabChange={toggle}
      />
      <Card className="border-0 card-box">
        <CardBody>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={DASHBOARD_TABS.LISTINGS}>
              {activeTab === DASHBOARD_TABS.LISTINGS && (
                <Listings canView={permissions?.listing} />
              )}
            </TabPane>
            <TabPane tabId={DASHBOARD_TABS.BIDS}>
              {activeTab === DASHBOARD_TABS.BIDS && <Bids />}
            </TabPane>
            <TabPane tabId={DASHBOARD_TABS.VENDORS}>
              {activeTab === DASHBOARD_TABS.VENDORS && <Vendors />}
            </TabPane>
            <TabPane tabId={DASHBOARD_TABS.INVOICES}>
              {activeTab === DASHBOARD_TABS.INVOICES && <Invoices />}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default AllTabsAndTables;
